import { MerchantDto } from "../../dto/merchant.dto";

export interface MerchantWithHours {
    merchant: MerchantDto;
    openingTime?: Date;
    closingTime?: Date;
    previousOpeningTime?: Date;
    previousClosingTime?: Date;
    isAvailable?: boolean;
}